import type { IFilter } from '@models/Filter'

import { apiClient } from '../../gateways/api'
import type { ProjectdossiersSearch } from '../types/ProjectdossiersSearch'

export { searchProjectdossiers, createFilters, initialState }

const initialState: ProjectdossiersSearch = {
  data: { count: 0, skip: 0, limit: 25, items: [] },
  query: {
    filters: {
      gebied: [],
      status: null,
      open: true,
      verantwoordelijke: null,
      projectdossierId: null,
    },
    sort: { sortBy: 'aanlegger.date', sortDirection: 'desc' },
    page: { skip: 0, limit: 25 },
  },
}

const createFilters = ({
  gebied,
  status,
  open,
  verantwoordelijke,
  projectdossierId,
}) => {
  const filters: IFilter[] = []

  if (gebied && gebied.length > 0)
    filters.push({
      name: 'gebiedscode',
      value: gebied.map(({ code }) => code),
      operator: 'in',
    })
  if (status)
    filters.push({ name: 'status', value: status.code, operator: 'eq' })

  if (open) filters.push({ name: 'status', value: 'gereed', operator: 'ne' })

  if (verantwoordelijke)
    filters.push({
      name: 'aanlegger.organisatie',
      value: verantwoordelijke.label,
      operator: 'eq',
    })

  if (projectdossierId)
    filters.push({
      name: 'projectdossierId',
      value: projectdossierId,
      operator: 'eq',
    })

  return filters
}

const searchProjectdossiers = async ({
  query,
}: {
  query: ProjectdossiersSearch['query']
}): Promise<ProjectdossiersSearch['data']> => {
  const { filters, page, sort } = query

  const { data } = await apiClient({
    url: '/rest/projectdossier/search',
    method: 'POST',
    data: { filters: createFilters(filters), ...page, ...sort },
  })

  return data
}
